import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Curated top-level shelves shown as pills on the Shop landing.
// The full DB now holds ~146 categories — the rest are still browsable via
// `fetchCategories()` (see below) which powers the "more categories" drawer
// and the Admin Inventory dropdown.
export const CATEGORIES = [
  { id: "all",                      label: "All Medicines" },
  { id: "pain-relief",              label: "Pain Relief" },
  { id: "cold-flu",                 label: "Cold & Flu" },
  { id: "cough-and-cold",           label: "Cough & Cold" },
  { id: "fever",                    label: "Fever" },
  { id: "allergies",                label: "Allergies" },
  { id: "supplements",              label: "Vitamins & Supplements" },
  { id: "hypertension",             label: "Hypertension" },
  { id: "diabetes",                 label: "Diabetes" },
  { id: "high-cholesterol",         label: "Cholesterol" },
  { id: "chronic",                  label: "Chronic Care" },
  { id: "bacterial-infections",     label: "Antibiotics" },
  { id: "fungal-infections",        label: "Antifungals" },
  { id: "viral-infections",         label: "Antivirals" },
  { id: "ulcer-reflux-flatulence",  label: "Ulcer & Acidity" },
  { id: "asthma-copd",              label: "Asthma / COPD" },
  { id: "injectables",              label: "Injectables" },
  { id: "syrups",                   label: "Syrups & Drops" },
  { id: "topical",                  label: "Ointments & Creams" },
  { id: "skin-infections",          label: "Skin Care" },
  { id: "acne",                     label: "Acne" },
  { id: "eye-conditions",           label: "Eye Care" },
  { id: "oral-care-p",              label: "Oral Care" },
  { id: "hormonal-therapy",         label: "Hormonal Therapy" },
  { id: "first-aid",                label: "First Aid" },
  { id: "devices",                  label: "Devices" },
];

// Fetch every category slug + count from the live DB — used by the Shop's
// "More shelves" drawer and by the Admin Inventory dropdown so newly-imported
// categories become instantly discoverable without a code change.
export const fetchCategories = async () => {
  try {
    const { data } = await api.get("/medicines/categories");
    return Array.isArray(data) ? data : [];
  } catch { return []; }
};

export const rupees = (n) => `₹${Number(n).toFixed(2)}`;
